const cookieSecure = process.env.VUE_APP_COOKIE_SECURE == "true" ? true : null;
const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";

import moduleAuth from "./auth/moduleAuth.js";
import moduleProject from "./projects/moduleProject.js";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    project: moduleProject,
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_VUEX_KEY,
    })
  ]
});
